
	frappe.templates['sort_selector'] = `<div class="sort-selector">
	<div class="btn-group">
		<button class="btn btn-default btn-xs btn-order"
			data-value="{{ sort_order }}"
			title="{{ sort_order==="desc" ? __("descending") : __("ascending") }}">
			<span class="sort-order button-icon">
				<svg class="icon icon-sm">
					<use href="#icon-{{ sort_order==="desc" ? "arrow-down-wide-narrow" : "arrow-up-narrow-wide" }}"></use>
				</svg>
			</span>
		</button>
		<button type="button" class="btn btn-default btn-sm sort-selector-button text-nowrap" data-toggle="dropdown">
			<span class="dropdown-text hidden-sm">{{ __(sort_by_label, null, doctype) }}</span>
			<span>{{ frappe.utils.icon("chevron-down") }}</span>
			<ul class="dropdown-menu dropdown-menu-right">
				{% for value in options %}
					<a class="dropdown-item option" data-value="{{ value.fieldname }}">
						{{ __(value.label, null, doctype) }}
					</a>
				{% endfor %}
				</div>
		</button>
	</div>
</div>
`;
